import PropTypes from 'prop-types';
import React from 'react';

/**
 * A star rating out of 5, partly filled for averages (4.3 fills four and a
 * third stars). The number always sits beside it, so the stars are a
 * reading aid and never the only way to tell the score.
 */
const Stars = ({ value, size = 'text-base', testId }) => {
  const width = value === null || value === undefined ? 0 : Math.max(0, Math.min(5, value)) * 20;
  return (
    <span
      // w-max and self-start: as wide as its five stars and never stretched by
      // a flex or grid parent, or the filled share covers too much.
      className={`relative inline-block self-start w-max flex-none leading-none whitespace-nowrap ${size}`}
      role="img"
      aria-label={value === null || value === undefined ? 'No rating' : `${value} out of 5`}
      data-testid={testId}>
      <span className="text-slate-200" aria-hidden="true">
        ★★★★★
      </span>
      <span
        className="absolute inset-0 overflow-hidden text-amber-400"
        style={{ width: `${width}%` }}
        aria-hidden="true">
        ★★★★★
      </span>
    </span>
  );
};

Stars.propTypes = { value: PropTypes.number, size: PropTypes.string, testId: PropTypes.string };

export default Stars;
